import { uploadHost } from '../imports'

/**
 * Uploads direct to S3 and saves as asset
 */
class Uploader {
  constructor(file) {
    if (typeof window !== 'undefined') {
      const { DirectUpload } = require('@rails/activestorage')
      this.upload = new DirectUpload(
        file,
        `https://${uploadHost()}/api/public/direct_uploads`
      )
    }
  }

  async uploadAsset() {
    return new Promise((resolve, reject) => {
      this.upload.create(async (error, blob) => {
        if (error) {
            reject(error)
        } else {
            resolve(blob.signed_id)
        }
      })
    })
  }
}
export default Uploader